export class SpecialDayFormModel {
  constructor(specialDay = {}) {
    this.name = specialDay?.name || "";
    this.date = specialDay?.date || "";
  }
}
